export const BOT_DAMAGE_SIDE_POSITIONS = {
  shoulderRight: 'left-[30%]',
  shoulderLeft: 'left-[70%]',
  armRight: 'left-[20%]',
  armLeft: 'left-[80%]',
  legRight: 'left-[28%]',
  legLeft: 'left-[72%]'
}

export function getBotDamageValueClass(partKey, topClass) {
  const sideClass = BOT_DAMAGE_SIDE_POSITIONS[partKey]
  if (!sideClass) {
    return `${topClass} left-1/2 -translate-x-1/2 -translate-y-1/2`
  }

  return `${topClass} ${sideClass} -translate-x-1/2 -translate-y-1/2`
}
